import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";
import "./header.scss";

import { Link, NavLink } from "react-router-dom";
import "bootstrap/dist/js/bootstrap";
import {
  Menu,
  MenuItem,
  MenuButton,
  SubMenu,
  MenuHeader,
  MenuDivider,
  MenuRadioGroup,
} from "@szhsin/react-menu";
import { useEffect, useState } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { _SIGNOUT } from "../models/common/cognito-signout";
import { useStorage } from "../hooks/use-storage";
import { StorageKey } from "../constants";
import { resetAxiosAuthTokens } from "../apiclient/provider/axios";
import { Dropdown } from "rsuite";
import TouchIcon from '@rsuite/icons/Touch';
import OffIcon from '@rsuite/icons/Off';
import OffRoundIcon from '@rsuite/icons/OffRound';

export const SideNavbarTopMenuComponent = () => {
  const [menuClass, setMenuClass] = useState<string>(
    "menu-button dropdown-toggle"
  );
  const [menuProfile, setMenuProfile]=useState<string>(
    "menu-profile"
  )
  const [isLogout, setIsLogout] = useState(false);

  const [currentAuthState, setAuthState] = useStorage(
    StorageKey.AuthState,
    null
  );
const [userName, setUserName]=useState<string>("Sign Out");

  const profile = JSON.parse(localStorage.getItem(StorageKey.Profile));

  useEffect(() => {
    
    setMenuClass("menu-button dropdown-toggle");
    if (profile){
        if (profile?.name!=="" && profile?.name !==undefined){
            setUserName(profile?.name);
        }else{
          if (profile["cognito:username"]!=="" && profile["cognito:username"]!==undefined){
              setUserName(profile["cognito:username"]);
          }
        }
    }
  }, [menuClass, userName]);

  const signOutRedirect = () => {
    window.location.href = _SIGNOUT(window?.location?.hostname);
    sessionStorage.clear();
  };
  const onLogOutClick = () => {
    setIsLogout(true);
  };

  const onCancelDialog = () => {
    setIsLogout(false);
  };

  const onLogout = () => {
    window.location.href = "login";
    setAuthState(null);
    resetAxiosAuthTokens();
    signOutRedirect();
  };
  return (

    <>
      <div className="justify-content-between">
        <Menu
          menuButton={<MenuButton className={menuProfile}>
          <div className="d-flex ">
            {userName}
            <div className="ms-2"><OffRoundIcon/></div>
          
          </div>
          </MenuButton>}
          
        >
            <MenuItem>
              <Link to="/Settings" className="nav-link text-dark">
                Settings
              </Link>
            </MenuItem>
          <MenuItem>
            <Link to="/profile" className="nav-link text-dark">
              Profile
            </Link>
          </MenuItem>
          <MenuDivider />
          <MenuItem>
            <Link to="" onClick={onLogOutClick} className="nav-link text-dark">
              Logout
            </Link>
          </MenuItem>
        </Menu>
      </div>
      <div>
        {isLogout && (
          <Dialog title="Log Out" onClose={onCancelDialog}>
            <div>
              <h5>Are you sure you want to logout?</h5>
            </div>
            <DialogActionsBar>
              <div className="d-flex margin-fix mt-3 p-3">
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={onCancelDialog}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary ms-auto btn-sm"
                  onClick={onLogout}
                >
                  Logout
                </button>
              </div>
            </DialogActionsBar>
          </Dialog>
        )}
      </div>
    </>
  );
};
